import { useEffect } from 'react';

// Query children mount independently. Observe their tracks, not the query render order.
export default function useExploreShelves(root, entry, returning) {
  useEffect(() => {
    const node = root.current;
    if (!node) return;
    const attached = new Map();
    const attach = () => {
      node.querySelectorAll('.pp-shelf-track').forEach((rail) => {
        if (attached.has(rail)) return;
        const key = rail.getAttribute('aria-label');
        if (!key) return;
        if (returning) rail.scrollLeft = entry.exploreShelves?.[key] || 0;
        const save = () => {
          if (entry.current()) {
            entry.exploreShelves ||= {};
            entry.exploreShelves[key] = rail.scrollLeft;
          }
        };
        rail.addEventListener('scroll', save, { passive: true });
        attached.set(rail, save);
      });
    };
    attach();
    const observer = new MutationObserver(attach);
    observer.observe(node, { childList: true, subtree: true });
    return () => {
      observer.disconnect();
      attached.forEach((save, rail) => rail.removeEventListener('scroll', save));
    };
  }, [root, entry, returning]);
}
